import { Box, MenuItem, Select } from '@mui/material';
import { getSampleById } from 'actions/LaboratoryActions';
// import GeneralPwdHeader from 'PdfPages/components/PwdHeader';

// import GeneralPwdFooter from 'PdfPages/components/PwdFooter';

import A4 from 'PdfPages/pages/A4';
import { useEffect, useState } from 'react';
import useQuery from 'utils/getQueryParams';
import { connect } from 'react-redux';
import { IReducer } from 'Reducers/IReducer';
import { bindActionCreators } from 'redux';
import { ILaboratoryDetails } from 'Reducers/LaboratoryReducer/ILaboratoryReducer';
import { IMaster, ISample, IUser } from 'exactt-types/lib';
import GeneralFields, { GeneralFieldsValue } from 'PdfPages/components/GeneralFields';
import DocumentLatterHead from 'PdfPages/components/DocumentLatterHead';
import moment from 'moment';
import QRCode from 'react-qr-code';
import CircularProgress from '@mui/material/CircularProgress';

interface SampleResultPrintProps {
  setDisableScroll: (value: boolean) => void;
  getSampleById: (laboratoryId: string, _id: string) => Promise<any>;
  laboratory: ILaboratoryDetails | null;
  sampleDetails: ISample | null;
}

export function _SampleJobSheetPrint(props: SampleResultPrintProps) {
  let query = useQuery();
  let sampleId = query.get('id');
  const laboratoryId = props.laboratory?.details?._id;

  const [selectedUser, setSelectedUser] = useState('all');

  const userDirectory = (props.sampleDetails?.parameters || []).reduce((acc: Record<string, string>, parameter: any) => {
    const assignTo = parameter?.assignTo;
    const approvedBy = parameter?.approvedBy;

    if (assignTo && typeof assignTo === 'object' && assignTo._id) {
      acc[assignTo._id] = assignTo.name || '';
    }

    if (approvedBy && typeof approvedBy === 'object' && approvedBy._id) {
      acc[approvedBy._id] = approvedBy.name || '';
    }

    return acc;
  }, {});

  const getUserDisplayName = (value: any) => {
    if (!value) return '';
    if (typeof value === 'object') return value.name || '';
    return userDirectory[value] || '';
  };

  const filteredParameters =
    props.sampleDetails?.parameters?.filter((f) => {
      if (selectedUser === 'all') {
        return true;
      } else if (selectedUser === 'not_assigned') {
        // @ts-ignore
        return !(f.assignTo as IUser)?._id;
      } else {
        // @ts-ignore
        return (f.assignTo as IUser)?._id === selectedUser;
      }
    }) || [];

  const selectedApprovedBy =
    selectedUser === 'all'
      ? (props.sampleDetails?.parameters as any[])?.find((parameter: any) => parameter?.approvedBy)?.approvedBy
      : (filteredParameters as any[])?.find((parameter: any) => parameter?.approvedBy)?.approvedBy;

  useEffect(() => {
    props.setDisableScroll(true);

    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (!sampleId || !laboratoryId) {
      return;
    }

    props.getSampleById(laboratoryId, sampleId);
  }, [laboratoryId, sampleId]);

  const values: GeneralFieldsValue[] = [];

  if (props.sampleDetails) {
    values.push({ label: 'Commodity', value: props.sampleDetails.name });
    values.push({ label: 'Lab Code No.', value: (props.sampleDetails.sampleId || '').replace('HTL/', '') });
    values.push({
      label: 'Assigned To',
      value:
        selectedUser === 'all'
          ? 'All Users'
          : selectedUser === 'not_assigned'
            ? 'Not Assigned'
            : filteredParameters
                // @ts-ignore
                ?.map((i) => (i.assignTo as IUser)?.name)[0] || '',
    });
    values.push({ label: 'Date of Completion', value: '' });
    values.push({
      label: 'Date of receipt',
      value: moment(props.sampleDetails.collectionDate).format('DD-MM-YYYY') || '',
    });
  }

  let users = {};

  props.sampleDetails?.parameters?.map((i, index) => {
    // @ts-ignore
    if ((i.assignTo as IUser)?._id) {
      // @ts-ignore
      users[(i.assignTo as IUser)?._id] = i.assignTo as IUser;
    }
  });

  return (
    <Box>
      {/* Select for users */}
      <Select
        style={{ width: 500 }}
        size="small"
        className="no-print"
        value={selectedUser}
        onChange={(e) => setSelectedUser(e.target.value as string)}
      >
        <MenuItem value={'all'}>All</MenuItem>
        <MenuItem value={'not_assigned'}>Not Assigned</MenuItem>
        {Object.keys(users).map((i) => (
          <MenuItem value={i}>{users[i].name}</MenuItem>
        ))}
      </Select>
      {props.sampleDetails ? (
        <A4
          header={<DocumentLatterHead laboratory={props.laboratory} />}
          body={
            <>
              <Box mt={-0.5} border={'1px solid #000'} p={2}>
                <Box textAlign={'center'} mb={1} fontWeight={'bold'}>
                  JOB SHEET
                </Box>
                <GeneralFields values={values} labelWidth={134} />
                <Box display={'flex'} justifyContent={'flex-end'}>
                  <div>
                    <div style={{ height: 'auto', margin: '0 auto', maxWidth: 32, width: '100%' }}>
                      {props.sampleDetails.sampleId ? (
                        <QRCode
                          size={256}
                          style={{ height: 'auto', maxWidth: '100%', width: '100%' }}
                          value={props.sampleDetails.sampleId}
                          viewBox={`0 0 256 256`}
                        />
                      ) : null}
                    </div>
                  </div>
                </Box>
              </Box>
              <Box className="table-with-border">
                <table style={{ width: '100%' }}>
                  <thead>
                    <tr>
                      <th style={{ width: '6%' }}>Sr. No</th>
                      <th style={{ width: '30%' }}>Parameters</th>
                      <th style={{ width: '20%' }}>Result</th>
                      <th style={{ width: '10%' }}>Unit</th>
                      <th style={{ width: '10%' }}>Required as per FSSR-2011</th>
                      <th style={{ width: '30%' }}>Method of test to IS</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredParameters
                      ?.filter((f) => {
                        const findRow = (props.sampleDetails?.master as IMaster)?.parameters?.find(
                          (i) => f.name === i.name
                        );
                        f.method = findRow?.method;
                        return true;
                      })
                      ?.map((i, index) => (
                        <tr>
                          <td style={{ textAlign: 'center' }}>{index + 1}</td>
                          <td style={{ textAlign: 'center' }}>{i.name}</td>
                          <td></td>
                          <td style={{ textAlign: 'center' }}>{i.unit}</td>
                          <td>{i.requirements}</td>
                          <td>{i.method}</td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </Box>
            </>
          }
          footer={
            <>
              <div
                style={{ width: '100%', display: 'flex', justifyContent: 'space-around', gap: '10mm', marginTop: 40 }}
              >
                <div>
                  <strong>{selectedUser === 'all' ? 'All ' : (users[selectedUser] as IUser)?.name} </strong>
                  <br />
                  <strong style={{ fontSize: 12 }}>Analysed By</strong>
                </div>
                <div>
                  <strong>{getUserDisplayName(selectedApprovedBy)}</strong>
                  <br />
                  <strong style={{ fontSize: 12 }}>Approved By</strong>
                </div>
              </div>
            </>
          }
        />
      ) : (
        <Box
          minHeight={'60vh'}
          display={'flex'}
          flexDirection={'column'}
          alignItems={'center'}
          justifyContent={'center'}
          gap={2}
        >
          <CircularProgress size={28} />
          <Box color={'#666'}>Loading job sheet...</Box>
        </Box>
      )}
    </Box>
  );
}
const mapStateToProps = (state: IReducer) => ({
  laboratory: state.laboratory.current,
  sampleDetails: state.laboratory.sampleDetails,
});

function mapDispatchToProps(dispatch: any) {
  return {
    ...bindActionCreators(
      {
        getSampleById,
      },
      dispatch
    ),
  };
}

export const SampleJobSheetPrint = connect(mapStateToProps, mapDispatchToProps)(_SampleJobSheetPrint);
